import { GetValidAMLExistsApiCallResponse } from 'api/typegen/client/questionnaire/valid-aml-exists/get';
import fetchWebApi from 'api/fetchWebApi';

const getValidAMLExistsApiCall =
  async (): Promise<GetValidAMLExistsApiCallResponse> =>
    fetchWebApi('/client/questionnaire/valid-aml-exists');

export default getValidAMLExistsApiCall;
